var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "v-flex",
        { attrs: { md10: "" } },
        [
          _c(
            "v-card",
            [
              _c(
                "v-container",
                { attrs: { "grid-list-md": "" } },
                [
                  _c(
                    "div",
                    { attrs: { align: "left" } },
                    [
                      _c("v-flex", { attrs: { md12: "" } }, [
                        _c("h2", [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.creacion
                                  ? "Crear Devolución a Bodega Operaciones"
                                  : _vm.edicion
                                  ? "Editar Devolución a Bodega Operaciones"
                                  : _vm.visualizacion
                                  ? "Ver Devolución a Bodega Operaciones"
                                  : ""
                              ) +
                              "\n            "
                          )
                        ])
                      ])
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c("br"),
                  _c(
                    "v-layout",
                    { attrs: { wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        {
                          attrs: {
                            xs3: "",
                            sm3: "",
                            md3: "",
                            md4: !_vm.creacion
                          }
                        },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Número de Serie del Equipo *",
                              required: "",
                              disabled: !_vm.creacion
                            },
                            model: {
                              value: _vm.equipoSerieNumero,
                              callback: function($$v) {
                                _vm.equipoSerieNumero = $$v
                              },
                              expression: "equipoSerieNumero"
                            }
                          })
                        ],
                        1
                      ),
                      _vm.creacion
                        ? _c(
                            "v-flex",
                            {
                              staticClass: "d-flex mt-2",
                              attrs: { xs1: "", sm1: "", md1: "" }
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "mx-0",
                                  attrs: {
                                    flat: "",
                                    icon: "",
                                    small: "",
                                    disabled:
                                      !_vm.creacion || !_vm.equipoSerieNumero
                                  },
                                  on: { click: _vm.getComboTipoEquipos }
                                },
                                [_c("v-icon", [_vm._v("search")])],
                                1
                              ),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    flat: "",
                                    icon: "",
                                    small: "",
                                    disabled:
                                      !_vm.creacion || !_vm.equipoSerieNumero
                                  },
                                  on: {
                                    click: function() {
                                      _vm.equipoSerieNumero = ""
                                      _vm.arrComboTipoEquipos = []
                                      _vm.reestablecerDatos()
                                    }
                                  }
                                },
                                [_c("v-icon", [_vm._v("clear")])],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "v-flex",
                        { attrs: { xs4: "", sm4: "", md4: "" } },
                        [
                          _c("v-combobox", {
                            attrs: {
                              label: "Seleccione el Equipo *",
                              required: "",
                              disabled: !_vm.creacion,
                              items: _vm.arrComboTipoEquipos,
                              "item-text": "tipoeqname",
                              "item-value": "tipoeqid"
                            },
                            on: {
                              change: function($event) {
                                return _vm.traerInformacion(null, null)
                              }
                            },
                            model: {
                              value: _vm.equipoSeleccionado,
                              callback: function($$v) {
                                _vm.equipoSeleccionado = $$v
                              },
                              expression: "equipoSeleccionado"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { xs4: "", sm4: "", md4: "" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Requerimiento *",
                              required: "",
                              disabled: !_vm.creacion
                            },
                            on: { input: _vm.emitirParaGuardar },
                            model: {
                              value: _vm.requerimiento,
                              callback: function($$v) {
                                _vm.requerimiento = $$v
                              },
                              expression: "requerimiento"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { xs4: "", sm4: "", md4: "" } },
                        [
                          _c("v-combobox", {
                            attrs: {
                              label: "Coordinador *",
                              items: _vm.findFilterList({ key: "coorbaja" }),
                              "item-text": "coorname",
                              "item-value": "coorid",
                              required: "",
                              disabled: !_vm.creacion
                            },
                            on: { change: _vm.emitirParaGuardar },
                            model: {
                              value: _vm.coordinador,
                              callback: function($$v) {
                                _vm.coordinador = $$v
                              },
                              expression: "coordinador"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { xs4: "", sm4: "", md4: "" } },
                        [
                          _c("DatePicker", {
                            attrs: {
                              label: "Fecha Recepción del Equipo",
                              max: _vm.fechaMaxima,
                              disabled: !(
                                _vm.creacion ||
                                (_vm.edicion && _vm.data[0].devoanula == "")
                              )
                            },
                            on: { input: _vm.emitirParaGuardar },
                            model: {
                              value: _vm.fechaRecepcion,
                              callback: function($$v) {
                                _vm.fechaRecepcion = $$v
                              },
                              expression: "fechaRecepcion"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { xs4: "", sm4: "", md4: "" } },
                        [
                          _c("DatePicker", {
                            attrs: {
                              label: "Fecha de Registro",
                              max: _vm.fechaMaxima,
                              disabled: ""
                            },
                            model: {
                              value: _vm.fecha,
                              callback: function($$v) {
                                _vm.fecha = $$v
                              },
                              expression: "fecha"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { xs4: "", sm4: "", md4: "" } },
                        [
                          _c("v-text-field", {
                            attrs: { label: "Usuario", disabled: "" },
                            model: {
                              value: _vm.usuario,
                              callback: function($$v) {
                                _vm.usuario = $$v
                              },
                              expression: "usuario"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { xs4: "", sm4: "", md4: "" } },
                        [
                          _c("v-select", {
                            attrs: {
                              label: "Estado de la Devolución",
                              items: ["VIGENTE", "ANULADO", "FINALIZADO"],
                              "item-text": "texto",
                              "item-value": "valor",
                              disabled: !_vm.edicion || _vm.devAnulada
                            },
                            on: {
                              change: function($event) {
                                _vm.mostrarConf = true
                              }
                            },
                            model: {
                              value: _vm.estado,
                              callback: function($$v) {
                                _vm.estado = $$v
                              },
                              expression: "estado"
                            }
                          }),
                          _c("modal-confirmacion", {
                            attrs: {
                              show: _vm.mostrarConf && _vm.estado == "ANULADO",
                              titulo: "¿Está seguro de anular la Devolución?",
                              mensaje: "Este cambio es irreversible",
                              textoBtnSi: "Continuar",
                              textoBtnNo: "Cancelar",
                              width: 450
                            },
                            on: { modalConfirmationEmit: _vm.anularDevo }
                          }),
                          _c("modal-confirmacion", {
                            attrs: {
                              show:
                                _vm.mostrarConf && _vm.estado == "FINALIZADO",
                              titulo:
                                "¿Está seguro de finalizar la Devolución?",
                              mensaje: "Este cambio es irreversible",
                              textoBtnSi: "Continuar",
                              textoBtnNo: "Cancelar",
                              width: 450
                            },
                            on: {
                              modalConfirmationEmit: _vm.finalizarDevolucion
                            }
                          })
                        ],
                        1
                      ),
                      _vm.arrComboTipoEquipos.length > 0
                        ? _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _vm.arrComboTipoEquipos.length > 0
                                ? _c("v-text-field", {
                                    attrs: {
                                      label: "Número de Serie del Equipo",
                                      required: "",
                                      disabled: ""
                                    },
                                    model: {
                                      value: _vm.equipoSerieNumero,
                                      callback: function($$v) {
                                        _vm.equipoSerieNumero = $$v
                                      },
                                      expression: "equipoSerieNumero"
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c("br"),
                  _c(
                    "v-layout",
                    { attrs: { wrap: "" } },
                    [
                      _vm.edicion || _vm.visualizacion
                        ? _c(
                            "v-flex",
                            [
                              _c("v-text-field", {
                                attrs: { label: "Equipo", disabled: "" },
                                model: {
                                  value: _vm.equipo,
                                  callback: function($$v) {
                                    _vm.equipo = $$v
                                  },
                                  expression: "equipo"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "v-flex",
                        { attrs: { xs4: "", sm4: "", md4: "" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Número de Activación",
                              disabled: ""
                            },
                            model: {
                              value: _vm.numeroActivacion,
                              callback: function($$v) {
                                _vm.numeroActivacion = $$v
                              },
                              expression: "numeroActivacion"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { xs4: "", sm4: "", md4: "" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Plataforma",
                              required: "",
                              disabled: ""
                            },
                            model: {
                              value: _vm.plataforma,
                              callback: function($$v) {
                                _vm.plataforma = $$v
                              },
                              expression: "plataforma"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { xs4: "", sm4: "", md4: "" } },
                        [
                          _c("v-checkbox", {
                            attrs: {
                              label: "Estado en Plataforma",
                              disabled: ""
                            },
                            model: {
                              value: _vm.registrada,
                              callback: function($$v) {
                                _vm.registrada = $$v
                              },
                              expression: "registrada"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { xs4: "", sm4: "", md4: "" } },
                        [
                          _c("v-text-field", {
                            attrs: { label: "SIM Serie Número", disabled: "" },
                            model: {
                              value: _vm.SIMSerieNumero,
                              callback: function($$v) {
                                _vm.SIMSerieNumero = $$v
                              },
                              expression: "SIMSerieNumero"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { xs4: "", sm4: "", md4: "" } },
                        [
                          _c("v-text-field", {
                            attrs: { label: "Estado SIM", disabled: "" },
                            model: {
                              value: _vm.estadoSim,
                              callback: function($$v) {
                                _vm.estadoSim = $$v
                              },
                              expression: "estadoSim"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { xs4: "", sm4: "", md4: "" } },
                        [
                          _c("DatePicker", {
                            attrs: {
                              label: "Fecha Baja de Serie *",
                              max: _vm.fechaMaxima,
                              required: "",
                              disabled: ""
                            },
                            model: {
                              value: _vm.fechaBajaSerie,
                              callback: function($$v) {
                                _vm.fechaBajaSerie = $$v
                              },
                              expression: "fechaBajaSerie"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }